<template>
  <cvc-card
    style="min-height: 400px"
    :failed="$store.state.profile.profileDefinitionsFailed"
    :loading="$store.getters.profileDefinitionsLoading"
    :skeleton-type-matrix="['card']"
    :skeleton-row-heights="[400]"
  >
    <profile-table :profile="profile" :set-profile="setProfile" />
    <v-container>
      <v-row>

      <v-col cols="6" class="pa-6">
        <v-row
          class="height-25 ma-0 font-size-medium-large font-weight-medium"
          style="margin-top: -4px"
        >
          Segment Details
        </v-row>
        <v-row class="px-2" v-if="profile">
          <query-builder
            :readonly="true"
            :initial-query="profile.query"
            :on-query-change="() => {}"
          />
        </v-row>
      </v-col>
      <v-col cols="6" class="pa-6">
        <v-row
          class="height-25 ma-0 font-size-medium-large font-weight-medium"
          style="margin-top: -4px"
        >
          Segment Description
        </v-row>
        <v-row class="px-2" v-if="profile">
          {{profile.description}}
        </v-row>
      </v-col>
      </v-row>
    </v-container>
  </cvc-card>
</template>

<script>
import ProfileTable from "@/components/ProfileTags/ProfileTable";
import CvcCard from "@/components/CvcCard";
import QueryBuilder from "@/components/ProfileBuilder/QueryBuilder";

export default {
  name: "AdvertisingSegments",
  components: {
    QueryBuilder,
    CvcCard,
    ProfileTable,
  },
  data() {
    return {
      profile: null,
    };
  },
  computed: {
    latestAction() {
      const profileActionData = this.$store.state.notifications
        .profileActionData;
      return profileActionData
        ? profileActionData[profileActionData.length - 1]
        : null;
    },
    latestPinpointCampaign() {
      const latestAction = this.latestAction;
      if (!latestAction || !latestAction.metadata) return null;

      const pinpoint_campaigns = latestAction.metadata.pinpoint_campaigns;
      return pinpoint_campaigns
        ? pinpoint_campaigns[pinpoint_campaigns.length - 1]
        : null;
    },
    profileActionResponsesData() {
      return this.$store.state.notifications.profileActionResponsesData;
    },
  },
  methods: {
    setProfile(profile) {
      this.profile = null;
      this.$nextTick(() => {
        this.profile = profile;
        this.$store.dispatch("getProfileActionData", { profile });
      });
    },
  },
};
</script>

<style lang="scss">
@import "src/styles/_mixins.scss";

.svg-funnel-js__label {
  .label__segment-percentages {
    display: none;
  }
}
.profile-tags {
  background-color: var(--v-colore-base);
  min-height: calc(100vh - 64px);
}
</style>
